import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-single-car-payments__wrapper -single-used"
}
const _hoisted_2 = { class: "c-single-car-payments" }
const _hoisted_3 = {
  key: 0,
  class: "c-single-car-payments__discount__wrapper"
}
const _hoisted_4 = { class: "c-single-car-payments__discount" }
const _hoisted_5 = { class: "c-single-car-payments__toggle__wrapper" }
const _hoisted_6 = { class: "c-single-car-payments__toggle" }
const _hoisted_7 = { class: "c-single-car-payments__toggle__label__wrapper" }
const _hoisted_8 = { class: "c-single-car-payments__expend-boxes__inner" }
const _hoisted_9 = { class: "c-single-car-payments-content__select -location-select" }
const _hoisted_10 = { class: "o-select__wrap" }
const _hoisted_11 = { class: "o-select__wrap" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "o-select__wrap" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "c-single-car-comptant c-single-car-neuf" }
const _hoisted_16 = { class: "c-single-car-neuf__row" }
const _hoisted_17 = { class: "c-single-car-row__accordion" }
const _hoisted_18 = { class: "c-single-car-row__accordion__header__inner" }
const _hoisted_19 = { class: "c-single-car-row__icon" }
const _hoisted_20 = { class: "c-single-car-payments-content__price" }
const _hoisted_21 = { class: "c-single-car-row__accordion__content" }
const _hoisted_22 = { class: "c-single-car-row__accordion__inner" }
const _hoisted_23 = { class: "c-single-car-price__table" }
const _hoisted_24 = {
  key: 0,
  class: "c-single-car-price__table__row"
}
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = {
  key: 0,
  class: "c-single-car-neuf__row"
}
const _hoisted_28 = { class: "c-single-car-row__accordion" }
const _hoisted_29 = { class: "c-single-car-row__accordion__header__inner" }
const _hoisted_30 = { class: "c-single-car-row__icon" }
const _hoisted_31 = { class: "c-single-car-payments-content__discount" }
const _hoisted_32 = { class: "c-single-car-row__accordion__content" }
const _hoisted_33 = { class: "c-single-car-row__accordion__inner" }
const _hoisted_34 = { class: "c-single-car-price__table" }
const _hoisted_35 = { class: "" }
const _hoisted_36 = { class: "" }
const _hoisted_37 = {
  key: 0,
  class: "c-single-car-price__table__info"
}
const _hoisted_38 = { class: "c-single-car-payments-content__row" }
const _hoisted_39 = { class: "o-input__wrap" }
const _hoisted_40 = { class: "c-single-car-payments-content__row" }
const _hoisted_41 = { class: "c-single-car-payments-content__taxes" }
const _hoisted_42 = { class: "c-single-car-payments-content__taxes__radio" }
const _hoisted_43 = { class: "c-single-car-payments-content__taxes__label" }
const _hoisted_44 = { class: "c-single-car-payments-content__taxes__row" }
const _hoisted_45 = { class: "c-single-car-payments-content__price" }
const _hoisted_46 = { class: "c-single-car-payments-content__price" }
const _hoisted_47 = { class: "c-single-car-payments-content__row" }
const _hoisted_48 = { class: "o-input__wrap" }
const _hoisted_49 = { class: "c-single-car-payments-content__row -total" }
const _hoisted_50 = { class: "c-single-car-payments-content__label" }
const _hoisted_51 = { class: "c-single-car-payments-content__price" }
const _hoisted_52 = { class: "c-single-car-payments-content__select" }
const _hoisted_53 = { class: "o-select__wrap" }
const _hoisted_54 = { class: "o-select__wrap" }
const _hoisted_55 = ["value"]
const _hoisted_56 = { class: "c-single-car-comptant c-single-car-neuf" }
const _hoisted_57 = { class: "c-single-car-neuf__row" }
const _hoisted_58 = { class: "c-single-car-row__accordion" }
const _hoisted_59 = { class: "c-single-car-row__accordion__header__inner" }
const _hoisted_60 = { class: "c-single-car-row__icon" }
const _hoisted_61 = { class: "c-single-car-payments-content__price" }
const _hoisted_62 = { class: "c-single-car-row__accordion__content" }
const _hoisted_63 = { class: "c-single-car-row__accordion__inner" }
const _hoisted_64 = { class: "c-single-car-price__table" }
const _hoisted_65 = {
  key: 0,
  class: "c-single-car-price__table__row"
}
const _hoisted_66 = { class: "" }
const _hoisted_67 = { class: "" }
const _hoisted_68 = {
  key: 0,
  class: "c-single-car-neuf__row"
}
const _hoisted_69 = { class: "c-single-car-row__accordion" }
const _hoisted_70 = { class: "c-single-car-row__accordion__header__inner" }
const _hoisted_71 = { class: "c-single-car-row__icon" }
const _hoisted_72 = { class: "c-single-car-payments-content__discount" }
const _hoisted_73 = { class: "c-single-car-row__accordion__content" }
const _hoisted_74 = { class: "c-single-car-row__accordion__inner" }
const _hoisted_75 = { class: "c-single-car-price__table" }
const _hoisted_76 = { class: "" }
const _hoisted_77 = { class: "" }
const _hoisted_78 = {
  key: 0,
  class: "c-single-car-price__table__info"
}
const _hoisted_79 = { class: "c-single-car-payments-content__row" }
const _hoisted_80 = { class: "o-input__wrap" }
const _hoisted_81 = { class: "c-single-car-payments-content__row" }
const _hoisted_82 = { class: "c-single-car-payments-content__taxes" }
const _hoisted_83 = { class: "c-single-car-payments-content__taxes__radio" }
const _hoisted_84 = { class: "c-single-car-payments-content__taxes__label" }
const _hoisted_85 = { class: "c-single-car-payments-content__taxes__row" }
const _hoisted_86 = { class: "c-single-car-payments-content__price" }
const _hoisted_87 = { class: "c-single-car-payments-content__price" }
const _hoisted_88 = { class: "c-single-car-payments-content__row" }
const _hoisted_89 = { class: "o-input__wrap" }
const _hoisted_90 = { class: "c-single-car-payments-content__row -total" }
const _hoisted_91 = { class: "c-single-car-payments-content__label" }
const _hoisted_92 = { class: "c-single-car-payments-content__price" }
const _hoisted_93 = { class: "c-single-car-comptant c-single-car-neuf" }
const _hoisted_94 = { class: "c-single-car-neuf__row" }
const _hoisted_95 = { class: "c-single-car-row__accordion" }
const _hoisted_96 = { class: "c-single-car-row__accordion__header__inner" }
const _hoisted_97 = { class: "c-single-car-row__icon" }
const _hoisted_98 = { class: "c-single-car-payments-content__price" }
const _hoisted_99 = { class: "c-single-car-row__accordion__content" }
const _hoisted_100 = { class: "c-single-car-row__accordion__inner" }
const _hoisted_101 = { class: "c-single-car-price__table" }
const _hoisted_102 = {
  key: 0,
  class: "c-single-car-price__table__row"
}
const _hoisted_103 = { class: "" }
const _hoisted_104 = { class: "" }
const _hoisted_105 = {
  key: 0,
  class: "c-single-car-neuf__row"
}
const _hoisted_106 = { class: "c-single-car-row__accordion" }
const _hoisted_107 = { class: "c-single-car-row__accordion__header__inner" }
const _hoisted_108 = { class: "c-single-car-row__icon" }
const _hoisted_109 = { class: "c-single-car-payments-content__discount" }
const _hoisted_110 = { class: "c-single-car-row__accordion__content" }
const _hoisted_111 = { class: "c-single-car-row__accordion__inner" }
const _hoisted_112 = { class: "c-single-car-price__table" }
const _hoisted_113 = { class: "" }
const _hoisted_114 = { class: "" }
const _hoisted_115 = {
  key: 0,
  class: "c-single-car-price__table__info"
}
const _hoisted_116 = { class: "c-single-car-payments-content__row" }
const _hoisted_117 = { class: "o-input__wrap" }
const _hoisted_118 = { class: "c-single-car-payments-content__row" }
const _hoisted_119 = { class: "c-single-car-payments-content__taxes" }
const _hoisted_120 = { class: "c-single-car-payments-content__taxes__radio" }
const _hoisted_121 = { class: "c-single-car-payments-content__taxes__label" }
const _hoisted_122 = { class: "c-single-car-payments-content__taxes__row" }
const _hoisted_123 = { class: "c-single-car-payments-content__price" }
const _hoisted_124 = { class: "c-single-car-payments-content__price" }
const _hoisted_125 = { class: "c-single-car-payments-content__row -total" }
const _hoisted_126 = { class: "c-single-car-payments-content__price" }
const _hoisted_127 = { class: "c-single-car-payments__expend-button__wrapper" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svgIco = _resolveComponent("svgIco")
  const _component_Note = _resolveComponent("Note")
  const _component_Programs = _resolveComponent("Programs")

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "c-single-car-payments__title__wrapper" }, [
            _createElementVNode("h2", { class: "c-single-car-payments__title" }, "Estimez vos paiements")
          ], -1 /* HOISTED */)),
          ($options.currentRebate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, "Rabais de " + _toDisplayString(_ctx.cash($options.currentRebate)), 1 /* TEXT */),
                _createVNode(_component_svgIco, { icon: "price-tag-fill" })
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              ($options.hasLease)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: _normalizeClass(["c-single-car-payments__toggle__button js-single-car-payments-button-1", {'-is-active': _ctx.show=='lease'}]),
                    onClick: _cache[0] || (_cache[0] = $event => {_ctx.show='lease'; _ctx.expanded = true})
                  }, _toDisplayString(_ctx.cents($options.leaseTotal)), 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true),
              ($options.hasFinance)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: _normalizeClass(["c-single-car-payments__toggle__button js-single-car-payments-button-1", {'-is-active': _ctx.show=='finance'}]),
                    onClick: _cache[1] || (_cache[1] = $event => {_ctx.show='finance'; _ctx.expanded = true})
                  }, _toDisplayString(_ctx.cents($options.financeTotal)), 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                class: _normalizeClass(["c-single-car-payments__toggle__button js-single-car-payments-button-1", {'-is-active': _ctx.show=='cash'}]),
                onClick: _cache[2] || (_cache[2] = $event => {_ctx.show='cash'; _ctx.expanded = true})
              }, _toDisplayString(_ctx.cash($options.cashTotal)), 3 /* TEXT, CLASS */)
            ]),
            _createElementVNode("div", _hoisted_7, [
              ($options.hasLease)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["c-single-car-payments__toggle__label js-single-car-payments-label-1", {'-is-active': _ctx.show=='lease'}]),
                    "data-active": "location-1"
                  }, "Location", 2 /* CLASS */))
                : _createCommentVNode("v-if", true),
              ($options.hasFinance)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(["c-single-car-payments__toggle__label js-single-car-payments-label-1", {'-is-active': _ctx.show=='finance'}]),
                    "data-active": "financement-1"
                  }, "Financement", 2 /* CLASS */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("span", {
                class: _normalizeClass(["c-single-car-payments__toggle__label js-single-car-payments-label-1", {'-is-active': _ctx.show=='cash'}]),
                "data-active": "comptant-1"
              }, "Comptant", 2 /* CLASS */)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["c-single-car-payments__expend-boxes", {'-is-expend': _ctx.expanded}])
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createCommentVNode(" Location "),
            ($options.hasLease)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["c-single-car-payments__expend__location js-single-car-item-1", {'-is-active': _ctx.show=='lease'}]),
                  "data-item-active": "location-1"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _withDirectives(_createElementVNode("select", {
                        class: "o-select o-select-simple",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.term) = $event))
                      }, _cache[24] || (_cache[24] = [
                        _createElementVNode("option", { value: "weekly" }, "Par semaine", -1 /* HOISTED */),
                        _createElementVNode("option", { value: "biweekly" }, "Aux 2 semaines", -1 /* HOISTED */),
                        _createElementVNode("option", { value: "monthly" }, "Mensuel", -1 /* HOISTED */)
                      ]), 512 /* NEED_PATCH */), [
                        [_vModelSelect, _ctx.term]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("select", {
                        class: "o-select o-select-simple",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.leaseMonths) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.leaseOptions, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: item.months,
                            key: item.months
                          }, _toDisplayString(item.months) + " mois / " + _toDisplayString(_ctx.pct(item.rate)), 9 /* TEXT, PROPS */, _hoisted_12))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 512 /* NEED_PATCH */), [
                        [_vModelSelect, _ctx.leaseMonths]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("select", {
                        class: "o-select o-select-simple",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.mileage) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.leaseMileage, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: item.value,
                            key: item.value
                          }, _toDisplayString(item.label), 9 /* TEXT, PROPS */, _hoisted_14))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 512 /* NEED_PATCH */), [
                        [_vModelSelect, _ctx.mileage]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createCommentVNode(" prix du véhicule "),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["c-single-car-row__accordion__section", {'-is-active': _ctx.leasePriceExpanded}])
                        }, [
                          _createElementVNode("div", {
                            class: "c-single-car-row__accordion__header",
                            onClick: _cache[6] || (_cache[6] = $event => (_ctx.leasePriceExpanded = !_ctx.leasePriceExpanded))
                          }, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                _createVNode(_component_svgIco, {
                                  icon: "more",
                                  class: "-icon-more"
                                }),
                                _createVNode(_component_svgIco, {
                                  icon: "less",
                                  class: "-icon-less"
                                })
                              ]),
                              _cache[25] || (_cache[25] = _createElementVNode("span", { class: "c-single-car-row__accordion__header__label" }, "Prix du véhicule", -1 /* HOISTED */))
                            ]),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.cents($options.leaseLines.priceTotal)), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.leaseLines.prices, (line, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    (line.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                          _createElementVNode("span", _hoisted_25, _toDisplayString(line.label), 1 /* TEXT */),
                                          _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.cents(line.value)), 1 /* TEXT */)
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ], 64 /* STABLE_FRAGMENT */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ])
                          ])
                        ], 2 /* CLASS */)
                      ])
                    ]),
                    _createCommentVNode(" Rabais "),
                    ($options.leaseLines.discountTotal)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["c-single-car-row__accordion__section", {'-is-active': _ctx.leaseDiscountExpanded}])
                            }, [
                              _createElementVNode("div", {
                                class: "c-single-car-row__accordion__header",
                                onClick: _cache[7] || (_cache[7] = $event => (_ctx.leaseDiscountExpanded = !_ctx.leaseDiscountExpanded))
                              }, [
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("div", _hoisted_30, [
                                    _createVNode(_component_svgIco, {
                                      icon: "more",
                                      class: "-icon-more"
                                    }),
                                    _createVNode(_component_svgIco, {
                                      icon: "less",
                                      class: "-icon-less"
                                    })
                                  ]),
                                  _cache[26] || (_cache[26] = _createElementVNode("span", { class: "c-single-car-row__accordion__header__label" }, "Rabais", -1 /* HOISTED */))
                                ]),
                                _createElementVNode("span", _hoisted_31, "-" + _toDisplayString(_ctx.cents($options.leaseLines.discountTotal)), 1 /* TEXT */)
                              ]),
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.leaseLines.discounts, (line, index) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                        (line.value)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: _normalizeClass(["c-single-car-price__table__row", {'-alt': line.value < 0}])
                                            }, [
                                              _createElementVNode("span", _hoisted_35, _toDisplayString(line.label), 1 /* TEXT */),
                                              _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.cents(line.value)), 1 /* TEXT */)
                                            ], 2 /* CLASS */))
                                          : _createCommentVNode("v-if", true)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    }), 128 /* KEYED_FRAGMENT */)),
                                    ($options.leaseLines.hasEcoRebate)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, _cache[27] || (_cache[27] = [
                                          _createElementVNode("h4", { class: "c-single-car-price__table__info__title" }, "Pourquoi retenons-nous les taxes?", -1 /* HOISTED */),
                                          _createElementVNode("p", null, "Le rabais doit être calculé après l’application des taxes de vente fédérales et provinciales. Afin d’obtenir le rabais exact dans la structure de prix présentée, nous devons déduire les taxes aux rabais octroyés par les différents paliers de gouvernement.", -1 /* HOISTED */)
                                        ])))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ])
                              ])
                            ], 2 /* CLASS */)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_38, [
                      _cache[28] || (_cache[28] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "Ajoutez une valeur d’échange :", -1 /* HOISTED */)),
                      _createElementVNode("span", _hoisted_39, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "o-input o-input-smaller",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.exchange) = $event)),
                          placeholder: "-0,00 $"
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            _ctx.exchange,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("label", _hoisted_43, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              name: "checkbox",
                              value: "1",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.includeTaxes) = $event))
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelCheckbox, _ctx.includeTaxes]
                            ]),
                            _cache[29] || (_cache[29] = _createElementVNode("span", null, "Inclure les taxes", -1 /* HOISTED */))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _cache[30] || (_cache[30] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "TPS :", -1 /* HOISTED */)),
                          _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.cents($options.financeTPS)), 1 /* TEXT */),
                          _cache[31] || (_cache[31] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "TVQ :", -1 /* HOISTED */)),
                          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.cents($options.financeTVQ)), 1 /* TEXT */)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _cache[32] || (_cache[32] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "Ajoutez un versement initial :", -1 /* HOISTED */)),
                      _createElementVNode("span", _hoisted_48, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "o-input o-input-smaller",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.initial) = $event)),
                          placeholder: "-0,00 $"
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            _ctx.initial,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("span", _hoisted_50, "Votre paiement par " + _toDisplayString($options.termText), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.cents($options.leaseTotal)), 1 /* TEXT */)
                    ])
                  ]),
                  _createVNode(_component_Note),
                  _createCommentVNode(" Programmes admissibles "),
                  _createVNode(_component_Programs, {
                    type: "finance",
                    row: $options.currentRow,
                    selectedPrograms: _ctx.selectedPrograms
                  }, null, 8 /* PROPS */, ["row", "selectedPrograms"])
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Financement "),
            ($options.hasFinance)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["c-single-car-payments__expend__financement js-single-car-item-1", {'-is-active':  _ctx.show=='finance'}]),
                  "data-item-active": "financement-1"
                }, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _withDirectives(_createElementVNode("select", {
                        class: "o-select o-select-simple",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.term) = $event))
                      }, _cache[33] || (_cache[33] = [
                        _createElementVNode("option", { value: "weekly" }, "Par semaine", -1 /* HOISTED */),
                        _createElementVNode("option", { value: "biweekly" }, "Aux 2 semaines", -1 /* HOISTED */),
                        _createElementVNode("option", { value: "monthly" }, "Mensuel", -1 /* HOISTED */)
                      ]), 512 /* NEED_PATCH */), [
                        [_vModelSelect, _ctx.term]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _withDirectives(_createElementVNode("select", {
                        class: "o-select o-select-simple",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.financeMonths) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.financeOptions, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: item.months,
                            key: item.months
                          }, _toDisplayString(item.months) + " mois / " + _toDisplayString(_ctx.pct(item.rate)), 9 /* TEXT, PROPS */, _hoisted_55))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 512 /* NEED_PATCH */), [
                        [_vModelSelect, _ctx.financeMonths]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createCommentVNode(" prix du véhicule "),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["c-single-car-row__accordion__section", {'-is-active': _ctx.financePriceExpanded}])
                        }, [
                          _createElementVNode("div", {
                            class: "c-single-car-row__accordion__header",
                            onClick: _cache[13] || (_cache[13] = $event => (_ctx.financePriceExpanded = !_ctx.financePriceExpanded))
                          }, [
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("div", _hoisted_60, [
                                _createVNode(_component_svgIco, {
                                  icon: "more",
                                  class: "-icon-more"
                                }),
                                _createVNode(_component_svgIco, {
                                  icon: "less",
                                  class: "-icon-less"
                                })
                              ]),
                              _cache[34] || (_cache[34] = _createElementVNode("span", { class: "c-single-car-row__accordion__header__label" }, "Prix du véhicule", -1 /* HOISTED */))
                            ]),
                            _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.cents($options.financeLines.priceTotal)), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("div", _hoisted_64, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.financeLines.prices, (line, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    (line.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                          _createElementVNode("span", _hoisted_66, _toDisplayString(line.label), 1 /* TEXT */),
                                          _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.cents(line.value)), 1 /* TEXT */)
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ], 64 /* STABLE_FRAGMENT */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ])
                          ])
                        ], 2 /* CLASS */)
                      ])
                    ]),
                    _createCommentVNode(" Rabais "),
                    ($options.financeLines.discountTotal)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["c-single-car-row__accordion__section", {'-is-active': _ctx.financeDiscountExpanded}])
                            }, [
                              _createElementVNode("div", {
                                class: "c-single-car-row__accordion__header",
                                onClick: _cache[14] || (_cache[14] = $event => (_ctx.financeDiscountExpanded = !_ctx.financeDiscountExpanded))
                              }, [
                                _createElementVNode("div", _hoisted_70, [
                                  _createElementVNode("div", _hoisted_71, [
                                    _createVNode(_component_svgIco, {
                                      icon: "more",
                                      class: "-icon-more"
                                    }),
                                    _createVNode(_component_svgIco, {
                                      icon: "less",
                                      class: "-icon-less"
                                    })
                                  ]),
                                  _cache[35] || (_cache[35] = _createElementVNode("span", { class: "c-single-car-row__accordion__header__label" }, "Rabais", -1 /* HOISTED */))
                                ]),
                                _createElementVNode("span", _hoisted_72, "-" + _toDisplayString(_ctx.cents($options.financeLines.discountTotal)), 1 /* TEXT */)
                              ]),
                              _createElementVNode("div", _hoisted_73, [
                                _createElementVNode("div", _hoisted_74, [
                                  _createElementVNode("div", _hoisted_75, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.financeLines.discounts, (line, index) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                        (line.value)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: _normalizeClass(["c-single-car-price__table__row", {'-alt': line.value < 0}])
                                            }, [
                                              _createElementVNode("span", _hoisted_76, _toDisplayString(line.label), 1 /* TEXT */),
                                              _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.cents(line.value)), 1 /* TEXT */)
                                            ], 2 /* CLASS */))
                                          : _createCommentVNode("v-if", true)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    }), 128 /* KEYED_FRAGMENT */)),
                                    ($options.financeLines.hasEcoRebate)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_78, _cache[36] || (_cache[36] = [
                                          _createElementVNode("h4", { class: "c-single-car-price__table__info__title" }, "Pourquoi retenons-nous les taxes?", -1 /* HOISTED */),
                                          _createElementVNode("p", null, "Ce rabais doit être calculé après l’application des taxes de vente fédérales et provinciales. Afin d’obtenir le rabais exact dans la structure de prix présentée, nous devons déduire les taxes aux rabais octroyés par les différents paliers de gouvernement.", -1 /* HOISTED */)
                                        ])))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ])
                              ])
                            ], 2 /* CLASS */)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_79, [
                      _cache[37] || (_cache[37] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "Ajoutez une valeur d’échange :", -1 /* HOISTED */)),
                      _createElementVNode("span", _hoisted_80, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "o-input o-input-smaller",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((_ctx.exchange) = $event)),
                          placeholder: "-0,00 $"
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            _ctx.exchange,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("label", _hoisted_84, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              name: "checkbox",
                              value: "1",
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((_ctx.includeTaxes) = $event))
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelCheckbox, _ctx.includeTaxes]
                            ]),
                            _cache[38] || (_cache[38] = _createElementVNode("span", null, "Inclure les taxes", -1 /* HOISTED */))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_85, [
                          _cache[39] || (_cache[39] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "TPS :", -1 /* HOISTED */)),
                          _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.cents($options.financeTPS)), 1 /* TEXT */),
                          _cache[40] || (_cache[40] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "TVQ :", -1 /* HOISTED */)),
                          _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.cents($options.financeTVQ)), 1 /* TEXT */)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                      _cache[41] || (_cache[41] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "Ajoutez un versement initial :", -1 /* HOISTED */)),
                      _createElementVNode("span", _hoisted_89, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "o-input o-input-smaller",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => ((_ctx.initial) = $event)),
                          placeholder: "-0,00 $"
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            _ctx.initial,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("span", _hoisted_91, "Votre paiement par " + _toDisplayString($options.termText), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.cents($options.financeTotal)), 1 /* TEXT */)
                    ])
                  ]),
                  _createVNode(_component_Note),
                  _createCommentVNode(" Programmes admissibles "),
                  _createVNode(_component_Programs, {
                    type: "finance",
                    row: $options.currentRow,
                    selectedPrograms: _ctx.selectedPrograms
                  }, null, 8 /* PROPS */, ["row", "selectedPrograms"])
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Comptant "),
            _createElementVNode("div", {
              class: _normalizeClass(["c-single-car-payments__expend__comptant js-single-car-item-1", {'-is-active': _ctx.show=='cash'}]),
              "data-item-active": "comptant-1"
            }, [
              _cache[50] || (_cache[50] = _createElementVNode("div", { class: "c-single-car-payments-content__select" }, null, -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_93, [
                _createCommentVNode(" prix du véhicule "),
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["c-single-car-row__accordion__section", {'-is-active': _ctx.cashPriceExpanded}])
                    }, [
                      _createElementVNode("div", {
                        class: "c-single-car-row__accordion__header",
                        onClick: _cache[18] || (_cache[18] = $event => (_ctx.cashPriceExpanded = !_ctx.cashPriceExpanded))
                      }, [
                        _createElementVNode("div", _hoisted_96, [
                          _createElementVNode("div", _hoisted_97, [
                            _createVNode(_component_svgIco, {
                              icon: "more",
                              class: "-icon-more"
                            }),
                            _createVNode(_component_svgIco, {
                              icon: "less",
                              class: "-icon-less"
                            })
                          ]),
                          _cache[42] || (_cache[42] = _createElementVNode("span", { class: "c-single-car-row__accordion__header__label" }, "Prix du véhicule", -1 /* HOISTED */))
                        ]),
                        _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.cents($options.cashLines.priceTotal)), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_99, [
                        _createElementVNode("div", _hoisted_100, [
                          _createElementVNode("div", _hoisted_101, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.cashLines.prices, (line, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                (line.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                      _createElementVNode("span", _hoisted_103, _toDisplayString(line.label), 1 /* TEXT */),
                                      _createElementVNode("span", _hoisted_104, _toDisplayString(_ctx.cents(line.value)), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ])
                      ])
                    ], 2 /* CLASS */)
                  ])
                ]),
                _createCommentVNode(" Rabais "),
                ($options.cashLines.discountTotal)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                      _createElementVNode("div", _hoisted_106, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["c-single-car-row__accordion__section", {'-is-active': _ctx.cashDiscountExpanded}])
                        }, [
                          _createElementVNode("div", {
                            class: "c-single-car-row__accordion__header",
                            onClick: _cache[19] || (_cache[19] = $event => (_ctx.cashDiscountExpanded = !_ctx.cashDiscountExpanded))
                          }, [
                            _createElementVNode("div", _hoisted_107, [
                              _createElementVNode("div", _hoisted_108, [
                                _createVNode(_component_svgIco, {
                                  icon: "more",
                                  class: "-icon-more"
                                }),
                                _createVNode(_component_svgIco, {
                                  icon: "less",
                                  class: "-icon-less"
                                })
                              ]),
                              _cache[43] || (_cache[43] = _createElementVNode("span", { class: "c-single-car-row__accordion__header__label" }, "Rabais", -1 /* HOISTED */))
                            ]),
                            _createElementVNode("span", _hoisted_109, "-" + _toDisplayString(_ctx.cents($options.cashLines.discountTotal)), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_110, [
                            _createElementVNode("div", _hoisted_111, [
                              _createElementVNode("div", _hoisted_112, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.cashLines.discounts, (line, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    (line.value)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: _normalizeClass(["c-single-car-price__table__row", {'-alt': line.value < 0}])
                                        }, [
                                          _createElementVNode("span", _hoisted_113, _toDisplayString(line.label), 1 /* TEXT */),
                                          _createElementVNode("span", _hoisted_114, _toDisplayString(_ctx.cents(line.value)), 1 /* TEXT */)
                                        ], 2 /* CLASS */))
                                      : _createCommentVNode("v-if", true)
                                  ], 64 /* STABLE_FRAGMENT */))
                                }), 128 /* KEYED_FRAGMENT */)),
                                ($options.cashLines.hasEcoRebate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_115, _cache[44] || (_cache[44] = [
                                      _createElementVNode("h4", { class: "c-single-car-price__table__info__title" }, "Pourquoi retenons-nous les taxes?", -1 /* HOISTED */),
                                      _createElementVNode("p", null, "Le rabais doit être calculé après l’application des taxes de vente fédérales et provinciales. Afin d’obtenir le rabais exact dans la structure de prix présentée, nous devons déduire les taxes aux rabais octroyés par les différents paliers de gouvernement.", -1 /* HOISTED */)
                                    ])))
                                  : _createCommentVNode("v-if", true)
                              ])
                            ])
                          ])
                        ], 2 /* CLASS */)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_116, [
                  _cache[45] || (_cache[45] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "Ajoutez une valeur d’échange :", -1 /* HOISTED */)),
                  _createElementVNode("span", _hoisted_117, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "o-input o-input-smaller",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => ((_ctx.exchange) = $event)),
                      placeholder: "-0,00 $"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        _ctx.exchange,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_118, [
                  _createElementVNode("div", _hoisted_119, [
                    _createElementVNode("div", _hoisted_120, [
                      _createElementVNode("label", _hoisted_121, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          name: "checkbox",
                          value: "1",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => ((_ctx.includeTaxes) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelCheckbox, _ctx.includeTaxes]
                        ]),
                        _cache[46] || (_cache[46] = _createElementVNode("span", null, "Inclure les taxes", -1 /* HOISTED */))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_122, [
                      _cache[47] || (_cache[47] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "TPS :", -1 /* HOISTED */)),
                      _createElementVNode("span", _hoisted_123, _toDisplayString(_ctx.cents($options.cashTPS)), 1 /* TEXT */),
                      _cache[48] || (_cache[48] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "TVQ :", -1 /* HOISTED */)),
                      _createElementVNode("span", _hoisted_124, _toDisplayString(_ctx.cents($options.cashTVQ)), 1 /* TEXT */)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_125, [
                  _cache[49] || (_cache[49] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "Votre paiement", -1 /* HOISTED */)),
                  _createElementVNode("span", _hoisted_126, _toDisplayString(_ctx.cents($options.cashTotal)), 1 /* TEXT */)
                ])
              ]),
              _createVNode(_component_Note),
              _createCommentVNode(" Programmes admissibles "),
              _createVNode(_component_Programs, {
                type: "cash",
                row: $options.currentRow,
                selectedPrograms: _ctx.selectedPrograms
              }, null, 8 /* PROPS */, ["row", "selectedPrograms"])
            ], 2 /* CLASS */)
          ])
        ], 2 /* CLASS */),
        _createElementVNode("div", _hoisted_127, [
          _createElementVNode("button", {
            class: _normalizeClass(["c-single-car-payments__expend-button", {'-is-active': _ctx.expanded}]),
            onClick: _cache[22] || (_cache[22] = $event => (_ctx.expanded=!_ctx.expanded))
          }, [
            _createVNode(_component_svgIco, { icon: "arrow-down-slim" })
          ], 2 /* CLASS */)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}